import { Editor } from 'grapesjs';
import { FontAttributes } from '@loyalty/shared-common/template-api-client';
import { getFontsContentCss, getFontsToolbarCss } from '@loyalty/quill';
import { injectCss } from './inject-css';

export function injectQuillFontsStyles(editor: Editor, fonts: FontAttributes[]): void {
  injectCss(
    editor,
    'quill-custom-fonts',
    [getFontsToolbarCss(fonts), getFontsContentCss(fonts)].join('\n'),
  );
}
